import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export type DefaultThresholdRow = {
  /** Configured stage name (left column). */
  name: string;
  /** Formatted default range for that stage (right column). */
  range: string;
};

export type DefaultThresholdsTableProps = {
  /** First-column header (e.g. "Visit Stages"); the value column header is blank. */
  title: string;
  rows: DefaultThresholdRow[];
  'data-testid'?: string;
};

/**
 * A MUI basic table listing one axis's recommended default stage boundaries —
 * stage name in the first column, formatted range in the (header-less) second.
 * Two of these make up the Settings "Default Thresholds" card.
 */
const GuestJourneyDefaultThresholdsTable = ({
  title,
  rows,
  'data-testid': dataTestId = 'GuestJourney.Settings.DefaultThresholdsTable',
}: DefaultThresholdsTableProps) => (
  <TableContainer data-testid={dataTestId}>
    <Table size="small" aria-label={title}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: 'bold' }}>{title}</TableCell>
          <TableCell align="right" />
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <TableRow key={row.name}>
            <TableCell component="th" scope="row">
              {row.name}
            </TableCell>
            <TableCell align="right">{row.range}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default GuestJourneyDefaultThresholdsTable;
